<!-- main content start -->
<div class="main-content">
    <div class="breadcrumb mb-30">
        <h2>Categories</h2>
    </div>
    <div class="row g-4">
        <div class="col-xxl-4 col-md-5">
            <div class="panel">
                <div class="panel-header">
                    <h5>Add New Category</h5>
                    <button class="btn btn-sm btn-icon btn-outline-primary" (click)="clearForm()">
                        <i class="fa fa-arrows-rotate"></i>
                    </button>
                </div>
                <form [formGroup]="addCategory">

                    <div class="panel-body">
                        <div class="row gx-3 gy-5">

                            <!-- Category Name -->
                            <div class="col-12">
                                <label class="form-label">Category Name</label>
                                <input type="text" class="form-control form-control-sm" formControlName="name"
                                    [class.is-invalid]="f['name'].touched && f['name'].invalid">

                                <div class="text-danger mt-1"
                                    *ngIf="f['name'].touched && f['name'].errors?.['required']">
                                    Category Name is required.
                                </div>
                                <div class="text-danger mt-1"
                                    *ngIf="f['name'].touched && f['name'].errors?.['minlength']">
                                    Minimum 3 characters required.
                                </div>
                            </div>

                            <!-- Parent Category -->
                            <div class="col-sm-6" *ngIf="false">
                                <label class="form-label">Main Category</label>
                                <select class="form-select" formControlName="parent_id"
                                    [class.is-invalid]="f['parent_id'].touched && f['parent_id'].invalid">
                                    <option value="">Select</option>
                                    <option *ngFor="let item of categoryListData" [value]="item.id">{{item.name}}
                                    </option>
                                </select>

                                <div class="text-danger mt-1"
                                    *ngIf="f['parent_id'].touched && f['parent_id'].errors?.['required']">
                                    Please select a parent category.
                                </div>
                            </div>

                            <!-- Show in menu -->
                            <div class="col-6">
                                <label class="form-label">Show in menu</label>
                                <input class="form-check-input" type="checkbox" formControlName="is_menu"
                                    [class.is-invalid]="f['is_menu'].touched && f['is_menu'].invalid">

                                <div class="text-danger mt-1"
                                    *ngIf="f['is_menu'].touched && f['is_menu'].errors?.['required']">
                                    Must be checked to show in menu.
                                </div>
                            </div>

                            <!-- Allow On -->
                            <div class="col-6">
                                <label class="form-label">Allow On</label>
                                <select class="form-select" formControlName="allow_on"
                                    [class.is-invalid]="f['allow_on'].touched && f['allow_on'].invalid">
                                    <option value="">Default</option>
                                    <option value="web">Web</option>
                                    <option value="mobile">Mobile</option>
                                    <option value="both">Both</option>
                                </select>

                                <div class="text-danger mt-1"
                                    *ngIf="f['allow_on'].touched && f['allow_on'].errors?.['required']">
                                    Please choose an option.
                                </div>
                            </div>

                            <!-- Description -->
                            <div class="col-12">
                                <label class="form-label">Description</label>
                                <textarea rows="5" class="form-control form-control-sm"
                                    formControlName="description"></textarea>

                                <!-- <div class="text-danger mt-1" *ngIf="f['description'].touched && f['description'].errors?.['required']">
          Description is required.
        </div>
        <div class="text-danger mt-1" *ngIf="f['description'].touched && f['description'].errors?.['minlength']">
          Minimum 30 characters required.
        </div> -->
                            </div>

                            <!-- Display Type -->
                            <!-- <div class="col-12">
        <label class="form-label">Select parent category</label>
        <select class="form-select"
                formControlName="display_type"
                [class.is-invalid]="f['display_type'].touched && f['display_type'].invalid">
          <option value="">Default</option>
          <option value="farming">Farming1</option>
          <option value="Farming2">Farming2</option>
        </select>

        <div class="text-danger mt-1" *ngIf="f['display_type'].touched && f['display_type'].errors?.['required']">
          Display type is required.
        </div>
      </div> -->

                            <!-- Category Image -->
                            <div class="col-12">
                                <div class="upload-category-thumbnail">
                                    <label class="form-label" for="thumbUpload">Add Category Image</label>
                                    <input class="form-control" #fileInput type="file" accept="image/*"
                                        (change)="onImageChange($event)"
                                        [class.is-invalid]="f['categoryThumbnail'].touched && f['categoryThumbnail'].invalid">

                                    <div class="text-danger mt-1"
                                        *ngIf="f['categoryThumbnail'].touched && f['categoryThumbnail'].errors?.['required']">
                                        Category image is required.
                                    </div>

                                    <div class="mt-2" *ngIf="imagePreview">
                                        <img [src]="imagePreview" width="120" height="120" alt="Preview" />
                                    </div>
                                </div>
                            </div>

                            <!-- Buttons -->
                            <div class="col-12 d-flex justify-content-end">
                                <div class="btn-box">

                                    <button class="btn btn-sm btn-primary" *ngIf="isEdit"
                                        (click)="confirmBeforeSaveCategory('update')">
                                        Update Category
                                    </button>

                                    <button class="btn btn-sm btn-primary" *ngIf="!isEdit"
                                        (click)="confirmBeforeSaveCategory('add')" [disabled]="addCategory.invalid">
                                        Add Category
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>

                </form>

            </div>
        </div>
        <div class="col-xxl-8 col-md-7">
            <div class="panel">
                <div class="panel-header">
                    <h5>All Categories</h5>
                    <div class="btn-box d-flex gap-2">
                        <div id="tableSearch"></div>
                        <button class="btn btn-sm btn-icon btn-outline-primary"><i
                                class="fa fa-arrows-rotate"></i></button>
                        <!-- <div class="digi-dropdown dropdown">
                            <button class="btn btn-sm btn-icon btn-outline-primary" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"><i class="fa fa-ellipsis-vertical"></i></button>
                            <ul class="digi-dropdown-menu dropdown-menu">
                                <li class="dropdown-title">Show Table Title</li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showName" checked>
                                        <label class="form-check-label" for="showName">
                                            Name
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showDescription" checked>
                                        <label class="form-check-label" for="showDescription">
                                            Description
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showSlug" checked>
                                        <label class="form-check-label" for="showSlug">
                                            Slug
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showCount" checked>
                                        <label class="form-check-label" for="showCount">
                                            Count
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="showAction" checked>
                                        <label class="form-check-label" for="showAction">
                                            Action
                                        </label>
                                    </div>
                                </li>
                                <li class="dropdown-title pb-1">Showing</li>
                                <li>
                                    <div class="input-group">
                                        <input type="number" class="form-control form-control-sm w-50" value="10">
                                        <button class="btn btn-sm btn-primary w-50">Apply</button>
                                    </div>
                                </li>
                            </ul>
                        </div> -->
                    </div>
                </div>
                <div class="panel-body">
                    <!-- <div class="table-filter-option">
                        <div class="row justify-content-between g-3">
                            <div class="col-xxl-4 col-6 col-xs-12">
                                <form class="row g-2">
                                    <div class="col-8">
                                        <select class="form-control form-control-sm" data-placeholder="Bulk action">
                                            <option value="">Bulk action</option>
                                            <option value="0">Edit</option>
                                            <option value="1">Move To Trash</option>
                                        </select>
                                    </div>
                                    <div class="col-4">
                                        <button class="btn btn-sm btn-primary w-100">Apply</button>
                                    </div>
                                </form>
                            </div>
                            <div class="col-xl-2 col-3 col-xs-12 d-flex justify-content-end">
                                <div id="productTableLength"></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="table-responsive">
                        <table class="table table-dashed table-hover digi-dataTable all-product-table table-striped"
                            id="allProductTable">
                            <thead>
                                <tr>
                                    <!-- <th class="no-sort">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="markAllProduct">
                                        </div>
                                    </th> -->
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Slug</th>
                                    <th>Product Count</th>
                                    <th class="position-sticky end-0">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (control of categoryListData; track $index) {

                                <tr>
                                    <!-- <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td> -->
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><img src="{{control.thumbnail}}" /></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">{{control.name}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">{{control.description}}</span></td>
                                    <td>{{control.slug}}</td>
                                    <td>{{control.products_count}}</td>

                                    <!-- <td><a href="all-product.html">10</a></td> -->
                                    <td class="position-sticky end-0">
                                        <div class="btn-box">
                                            <button type="button" (click)="openCategoryPreview(control)">
                                                <i class="fa fa-eye"></i>
                                            </button>
                                            <button><i class="fa fa-pen-to-square"
                                                    (click)="editCategory(control)"></i></button>
                                            <button class="text-danger" (click)="openDialog(control.id)"><i
                                                    class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                }
                                <!-- <tr>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><img src="../images/image.png" alt="image"></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">Fashion</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">The description is not prominent by default; however, some themes may show it.</span></td>
                                    <td>fashion</td>
                                    <td><a href="all-product.html">10</a></td>
                                    <td>
                                        <div class="btn-box">
                                            <button><i class="fa fa-eye"></i></button>
                                            <button><i class="fa fa-pen-to-square"></i></button>
                                            <button><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><i class="fa fa-vest"></i></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">Fashion</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">The description is not prominent by default; however, some themes may show it.</span></td>
                                    <td>fashion</td>
                                    <td><a href="all-product.html">10</a></td>
                                    <td>
                                        <div class="btn-box">
                                            <button><i class="fa fa-eye"></i></button>
                                            <button><i class="fa fa-pen-to-square"></i></button>
                                            <button><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><img src="../images/image.png" alt="image"></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">Fashion</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">The description is not prominent by default; however, some themes may show it.</span></td>
                                    <td>fashion</td>
                                    <td><a href="all-product.html">10</a></td>
                                    <td>
                                        <div class="btn-box">
                                            <button><i class="fa fa-eye"></i></button>
                                            <button><i class="fa fa-pen-to-square"></i></button>
                                            <button><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><i class="fa fa-vest"></i></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">Fashion</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">The description is not prominent by default; however, some themes may show it.</span></td>
                                    <td>fashion</td>
                                    <td><a href="all-product.html">10</a></td>
                                    <td>
                                        <div class="btn-box">
                                            <button><i class="fa fa-eye"></i></button>
                                            <button><i class="fa fa-pen-to-square"></i></button>
                                            <button><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox">
                                        </div>
                                    </td>
                                    <td>
                                        <div class="table-category-card">
                                            <div class="part-icon">
                                                <span><img src="../images/image.png" alt="image"></span>
                                            </div>
                                            <div class="part-txt">
                                                <span class="category-name">Fashion</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td><span class="table-dscr">The description is not prominent by default; however, some themes may show it.</span></td>
                                    <td>fashion</td>
                                    <td><a href="all-product.html">10</a></td>
                                    <td>
                                        <div class="btn-box">
                                            <button><i class="fa fa-eye"></i></button>
                                            <button><i class="fa fa-pen-to-square"></i></button>
                                            <button><i class="fa fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                    <!-- <div class="table-bottom-control"></div> -->
                </div>
            </div>
        </div>
    </div>

    <!-- footer start -->
    <div class="footer">
        <p>Copyright©
            <script>document.write(new Date().getFullYear())</script> All Rights Reserved By <span
                class="text-primary">Safure</span>
        </p>
    </div>
    <!-- footer end -->
</div>
<!-- main content end -->

<ng-template #categoryPreviewModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Category Preview</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-4">
                <img [src]="selectedCategory?.thumbnail"
                    [alt]="selectedCategory?.name || 'category image'"
                    class="img-fluid rounded border" />
            </div>
            <div class="col-md-8">
                <div class="mb-2"><strong>Name:</strong> {{ selectedCategory?.name || '-' }}
                </div>
                <div class="mb-2"><strong>Slug:</strong> {{ selectedCategory?.slug || '-' }}
                </div>
                <div class="mb-2"><strong>Products:</strong>
                    {{ selectedCategory?.productCount ?? 0 }}</div>
                <div class="mb-2"><strong>Allow On:</strong>
                    {{ selectedCategory?.allow_on || '-' }}</div>
                <div class="mb-2">
                    <strong>Show In Menu:</strong>
                    {{ selectedCategory?.is_menu ? 'Yes' : 'No' }}
                </div>
            </div>
            <div class="col-12">
                <strong>Description:</strong>
                <div class="border rounded p-2 mt-1 bg-light">
                    {{ selectedCategory?.description || '-' }}
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
    </div>
</ng-template>
